/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Session } from '../../models/session';

export interface SubscribeToSession$Params {
  session_id: string;
}

export function subscribeToSession(http: HttpClient, rootUrl: string, params: SubscribeToSession$Params, context?: HttpContext): Observable<StrictHttpResponse<Session>> {
  const rb = new RequestBuilder(rootUrl, subscribeToSession.PATH, 'get');
  if (params) {
    rb.path('session_id', params.session_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Session>;
    })
  );
}

subscribeToSession.PATH = '/sessions/{session_id}/subscribe';
